export default function throttle(callback, wait, context = this) {
  let timeout = null;
  let callbackArgs = null;

  const later = () => {
    callback.apply(context, callbackArgs);
    timeout = null;
  };

  return function () {
    callbackArgs = arguments;
    if (!timeout) {
      timeout = setTimeout(later, wait);
    }
  };
}
